/** Cholesky decomposition: returns lower-triangular L with L·Lᵀ = A. */
export function cholesky(a: number[][]): number[][] {
  const n = a.length;
  const l: number[][] = Array.from({ length: n }, () => new Array(n).fill(0));
  for (let i = 0; i < n; i++) {
    for (let j = 0; j <= i; j++) {
      let sum = 0;
      for (let k = 0; k < j; k++) sum += l[i][k] * l[j][k];
      if (i === j) {
        const d = a[i][i] - sum;
        if (d <= 0) {
          throw new Error(
            "Correlation matrix is not positive definite — check the correlation inputs.",
          );
        }
        l[i][j] = Math.sqrt(d);
      } else {
        l[i][j] = (a[i][j] - sum) / l[j][j];
      }
    }
  }
  return l;
}
